import { useState } from "react";
import { FullScreenModal } from "@circle-react-shared/ModalsV2/FullScreenModal";
import { ModalBody } from "./ModalBody";
import { ModalHeader } from "./ModalHeader";

export type ModalTab = "edit" | "analytics";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  signedId: string;
}

export const Modal = ({ isOpen, onClose, signedId }: ModalProps) => {
  const [selectedTab, setSelectedTab] = useState<ModalTab>("edit");

  return (
    <FullScreenModal isOpen={isOpen} onClose={onClose} shouldShowCloseButton>
      <FullScreenModal.Header className="!pb-0 !pt-4 md:!py-5">
        <ModalHeader
          onClose={onClose}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      </FullScreenModal.Header>
      <FullScreenModal.Body>
        <ModalBody selectedTab={selectedTab} signedId={signedId} />
      </FullScreenModal.Body>
    </FullScreenModal>
  );
};
